var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpends(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.917969 2.97333C0.917969 2.52508 1.09603 2.09519 1.41299 1.77823C1.72995 1.46127 2.15984 1.2832 2.60809 1.2832H16.1291C16.5773 1.2832 17.0072 1.46127 17.3242 1.77823C17.6411 2.09519 17.8192 2.52508 17.8192 2.97333V11.4239C17.8192 11.8722 17.6411 12.3021 17.3242 12.619C17.0072 12.936 16.5773 13.1141 16.1291 13.1141H2.60809C2.15984 13.1141 1.72995 12.936 1.41299 12.619C1.09603 12.3021 0.917969 11.8722 0.917969 11.4239V2.97333Z",
    stroke: "#64C073",
    strokeWidth: 0.86167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36721 9.73443C10.7674 9.73443 11.9024 8.59939 11.9024 7.19925C11.9024 5.7991 10.7674 4.66406 9.36721 4.66406C7.96707 4.66406 6.83203 5.7991 6.83203 7.19925C6.83203 8.59939 7.96707 9.73443 9.36721 9.73443Z",
    fill: "#64C073"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.917969 4.66345C1.81447 4.66345 2.67424 4.30732 3.30816 3.6734C3.94208 3.03948 4.29821 2.1797 4.29821 1.2832M14.4389 13.1141C14.4389 12.2176 14.7951 11.3578 15.429 10.7239C16.0629 10.0899 16.9227 9.73382 17.8192 9.73382",
    stroke: "#64C073",
    strokeWidth: 0.86167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpends);
export default __webpack_public_path__ + "static/media/spends.6e42f3aa252c09a139d3f72697a024ba.svg";
export { ForwardRef as ReactComponent };